import React from "react";
import WebScan from "../../../../../componets/_webScan";

class WebScam extends React.Component {
  render() {
    const { SIZE, Bs, files, setFiles, webCam, twain, mobile, hideWebScan } = this.props;
    return (
      <>
        <Bs
          modal
          show={true}
          onHide={hideWebScan}
          keyboard={true}
          backdrop="static"
          centered
          size={SIZE.LG}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>Scany štítku a dodacího listu</Bs>
          <Bs modalbody>
            <WebScan
              {...this.props}
              webCam={webCam}
              twain={twain}
              mobile={mobile}
              files={files}
              setFiles={setFiles}
              setMobile={setFiles}
              onKeyDown={setFiles}
            />
          </Bs>
        </Bs>
      </>
    );
  }
}

export default WebScam;
